<template>
  <div>
    <UserActionsWrap form-title="Enter<br> new password">
      <NewPasswordForm />
    </UserActionsWrap>
    <UserActionsNavigation />
  </div>
</template>

<script>
  import UserActionsWrap from "../components/UserActionsWrap";
  import NewPasswordForm from "../components/NewPasswordForm";
  import UserActionsNavigation from "../components/UserActionsNavigation";

  export default {
    name: "Registration",
    components: {
      UserActionsWrap,
      NewPasswordForm,
      UserActionsNavigation
    }
  }
</script>
